export default __webpack_public_path__ + "slices/main/assets/public/media/ca_21q2haw_toolkit2_ebook_cover.3b1fa964ce2fa69af9e8833404b1e04b.png";